import React from 'react';
import githubicon from '../images/github-mark.svg';
import twittericon from '../images/x.svg';

function Footer() {
    return (
        <footer>
            <div className="footer--container">
                <a href="https://github.com/focardozom" target="_blank" rel="noopener noreferrer">
                    <img className="git-logo" src={githubicon} alt="GitHub Icon" />
                </a>
                <a href="https://twitter.com/focardozom09" target="_blank" rel="noopener noreferrer">
                    <img className="x-logo" src={twittericon} alt="Twitter Icon" />
                </a>
            </div>
        </footer>
    );
}

export default Footer;